import type { JSX } from 'react'
import { RoofRack } from './RoofRack'
import { seasonColors } from './shared'

const sackPath = 'M207 111C203 100 209 89 221 85L224 81C227 77 237 77 240 81L243 85C256 89 263 100 259 111Z'
const bowPath = (x: number, y: number) =>
  `M${x} ${y}C${x - 6} ${y - 8} ${x - 12} ${y - 5} ${x - 7} ${y}Z` +
  `M${x} ${y}C${x + 6} ${y - 8} ${x + 12} ${y - 5} ${x + 7} ${y}Z`

export function SinterklaasRoofLoad(): JSX.Element {
  const { red, white, paper, paperEdge, jute, juteShade, rope } = seasonColors
  return (
    <g>
      <RoofRack />
      <rect x="140" y="86" width="34" height="25" rx="1" fill={red} />
      <g fill={white}>
        <rect x="154.6" y="86" width="4.8" height="25" />
        <rect x="140" y="96.4" width="34" height="4.4" />
        <path d={bowPath(157, 86)} />
      </g>
      <rect x="177.5" y="94" width="25" height="17" rx="1" fill={paper} stroke={paperEdge} strokeWidth="1" />
      <g fill={red}>
        <rect x="188" y="94" width="4" height="17" />
        <path d="M190 94C186 88 181 90 184 94ZM190 94C194 88 199 90 196 94Z" />
      </g>
      <path fill={jute} d={sackPath} />
      <path fill={juteShade} d="M246 88C255 93 260 101 259 111H247C250 103 250 95 246 88Z" />
      <rect x="222.5" y="81.5" width="19" height="3.6" rx="1.8" fill={rope} />
    </g>
  )
}
